<template>
  <div class="top" style="color:#666666">
    <div class="left">
      欢迎您，
      <span style="color:#64caff">{{name}}</span>
    </div>
    <div class="right">
      <div>{{new Date|formatDate('yyyy年MM月dd日')}}</div>
      <div title="修改密码" @click="setarr" class="top-right">
        <i class="el-icon-lock"></i>&nbsp;&nbsp;修改密码
      </div>
      <div>
        <el-dropdown trigger="click" @command="set">
          <span class="el-dropdown-link">
            <i class="el-icon-setting" style="color:#64caff" title="设置"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="0">起送配置</el-dropdown-item>
            <el-dropdown-item :command="1">打印机配置</el-dropdown-item>
            <el-dropdown-item :command="3">上传门店照片</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div @click="quit" title="退出登录">
        <span class="menu-icon tuichu"></span>
      </div>
    </div>
    <el-dialog title="起送配置" :visible.sync="dialogTableVisible" width="400px">
      <el-form
        ref="formInline"
        size="mini"
        :model="formInline"
        class="demo-ruleForm"
        label-width="100px"
        :rules="rules"
      >
        <el-row>
          <el-col>
            <el-form-item label="配送费" prop="expressFee">
              <el-input v-model="formInline.expressFee">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="订单起送费用" prop="minOrderAmt">
              <el-input v-model="formInline.minOrderAmt">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="包装盒费用" prop="packingBoxFee">
              <el-input v-model="formInline.packingBoxFee">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submited" size="mini">确定</el-button>
        <el-button @click="dialogTableVisible = false" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="打印机配置" :visible.sync="deviceVisible" width="380px">
      <el-form ref="formInlinezin" size="mini" :model="formInlinezin" class="demo-ruleForm">
        <el-row>
          <el-col :span="18">
            <el-form-item label>
              <el-input v-model="formInlinezin.macIdzin" placeholder="请输入打印机编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="margin-left:10px;">
            <el-form-item label>
              <el-button size="mini" type="primary" @click="building">绑定</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        :row-class-name="tableRowClassName"
        ref="multipleTable"
        :data="tableData3"
        size="mini"
        tooltip-effect="dark"
        style="width:100%"
        header-cell-class-name="cen"
        cell-class-name="cen"
        v-if="tableData3!=''"
      >
        <el-table-column prop="id" label="设备编号" width="255px"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="buildand(scope.row.id)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      @close="vlose"
      v-loading="loading"
      title="商户图片设置"
      :visible.sync="dialogTableVisible_3"
      width="760px"
    >
      <el-row :gutter="24" style="text-align:center">
        <croppa
          :remove-button-size="20"
          :width="720"
          :placeholder-font-size="16"
          :height="220"
          placeholder="选择图像"
          v-model="croppa"
        ></croppa>
        <div class="el-upload__tip" slot="tip">为了美观，请尽量上传360*220的图片</div>
        <div style="margin:20px 0 30px">
          <el-button size="mini" @click="croppa.rotate()">旋转</el-button>
          <el-button size="mini" @click="croppa.zoomIn()">放大</el-button>
          <el-button size="mini" @click="croppa.zoomOut()">缩小</el-button>
        </div>
        <div style="margin:20px 0 30px">仅支持JPG、GIF、PNG图片文件，且文件小于5M</div>
        <div style="text-align:center">
          <el-button type="primary" size="mini" @click="upImg()">上传</el-button>
          <el-button size="mini" @click="dialogTableVisible_3=false">取消</el-button>
        </div>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/httpjs.js";
import { mapMutations, mapState } from "vuex";
import { baseurl } from "../base.js";
export default {
  created() {},
  data() {
    var money = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else {
        let str = /^[0-9]{1,8}([.][0-9]{1,2})?$/;
        if (!str.test(value)) {
          callback(new Error("最大八位数字，两位小数"));
        } else {
          callback();
        }
      }
    };
    var kongge_p = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else {
        let str = /^\S+$/;
        if (!str.test(value)) {
          callback(new Error("请输入正确的菜品单价"));
        } else {
          callback();
        }
      }
    };
    return {
      tableData3: [],
      dialogTableVisible_3: false,
      rules: {
        expressFee: [
          { validator: money, trigger: "change" },
          { validator: kongge_p, trigger: "blur" }
        ],
        minOrderAmt: [
          { validator: money, trigger: "change" },
          { validator: kongge_p, trigger: "blur" }
        ],
        packingBoxFee: [
          { validator: money, trigger: "change" },
          { validator: kongge_p, trigger: "blur" }
        ]
      },
      formInline: {
        expressFee: "",
        minOrderAmt: "",
        packingBoxFee: ""
      },
      formInlinezin: {
        macId: "",
        macIdzin: ""
      },
      uploadurl: baseurl + "/w/merchant/uploadPic",
      header: {
        "Access-Control-Allow-Origin": "*",
        tokenId: localStorage.getItem("tokenId")
      },
      loading: false,
      dialogTableVisible: false,
      deviceVisible: false,
      name: localStorage.getItem("username"),
      id: "",
      croppa: {}
    };
  },
  methods: {
    ...mapMutations({
      addd: "add"
    }),
    buildand(id) {
      this.$http.post(`/w/machine/relieve/${id}`, {}).then(() => {
        this.$message({
          type: "success",
          message: "解绑成功"
        });
        this.deviceVisible = false;
      });
    },
    building() {
      this.$http
        .post(`/w/machine/bind/${this.formInlinezin.macIdzin}`, {})
        .then(() => {
          this.$message({
            type: "success",
            message: "绑定成功"
          });
          this.deviceVisible = false;
          this.formInlinezin.macIdzin = "";
          this.load();
        });
    },
    set(command) {
      switch (command) {
        case 0:
          this.dialogTableVisible = true;
          this.$refs["formInline"] && this.$refs["formInline"].resetFields();
          this.loadtwo();
          break;
        case 1:
          this.deviceVisible = true;
          this.load();
          break;
        case 3:
          this.dialogTableVisible_3 = true;
        default:
          break;
      }
    },
    setarr() {
      this.addd({
        menuUrl: "editPw",
        menuNm: "修改密码"
      });
    },
    vlose() {
      this.picImg = "";
    },
    upImg() {
      if (!this.croppa.hasImage()) {
        this.$message.error("请选择需要上传的图片！！！");
        return;
      }
      this.croppa.generateBlob(blob => {
        var fd = new FormData();
        fd.append("uploadFile", blob, "blob.png");
        this.$http.post(this.uploadurl, fd).then(r => {
          this.$message.success("上传成功！！！");
          this.dialogTableVisible_3 = false;
        });
      });
    },
    rotate() {
      this.croppa.rotate();
    },
    loadtwo() {
      this.$http.get(`/w/express_amt/s`, {}).then(data => {
        this.formInline = data.data;
        this.id = this.formInline.id;
        this.formInline.expressFee = (this.formInline.expressFee / 100).toFixed(
          2
        );
        this.formInline.minOrderAmt = (
          this.formInline.minOrderAmt / 100
        ).toFixed(2);
        this.formInline.packingBoxFee = (
          this.formInline.packingBoxFee / 100
        ).toFixed(2);
      });
    },
    load() {
      this.$http
        .post("/w/machine/s", {
          platCode: localStorage.getItem("platCode"),
          merId: localStorage.getItem("merId")
        })
        .then(data => {
          this.tableData3 = data.data;
        });
    },
    tableRowClassName({ row, rowIndex }) {},
    submited() {
      this.$refs["formInline"].validate(valid => {
        if (valid) {
          this.$http
            .post("/w/express_amt/add", {
              id: this.id,
              minOrderAmt: this.formInline.minOrderAmt * 100,
              packingBoxFee: this.formInline.packingBoxFee * 100,
              expressFee: this.formInline.expressFee * 100
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "配置成功"
              });
              this.dialogTableVisible = false;
            });
        }
      });
    },
    submitedadd() {},
    quit() {
      this.$http.post("/w/user/logout").then(() => {
        axios.defaults.headers.post["tokenId"] = null;
        localStorage.setItem("tokenId", "");
        this.$router.push("/login");
      });
    }
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #606266;
}

a:hover {
  color: #409eff;
}

.clor {
  color: #409eff;
}

.grid-content {
  padding: 15px 0;
}

.top {
  display: flex;
  height: 100%;
  color: #a99999;
}

.top > div,
.right > div {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.left {
  width: 300px;
}

.right {
  flex: 1;
  justify-content: flex-end;
}

.right i {
  font-size: 25px;
}

.right > div {
  padding: 0 20px;
}

.right > div:nth-child(2) {
  border-right: 2px solid #a99999;
  border-left: 2px solid #a99999;
  box-sizing: content-box;
}

.memo {
  max-height: 70px;
  overflow: hidden;
}

.img {
  width: 200px;
}

.cen {
  text-align: center;
}

.right {
  text-align: right;
}

.avatar-uploader {
  text-align: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .avatar-uploader-icon:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9;
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 360px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/headTop.vue